var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStatisticsCardIconRoound = function SvgStatisticsCardIconRoound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 48C37.5048 48 48.25 37.2548 48.25 24C48.25 10.7452 37.5048 0 24.25 0C10.9952 0 0.25 10.7452 0.25 24C0.25 37.2548 10.9952 48 24.25 48Z",
    fill: "url(#paint0_linear_3813_1167)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3813_1167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0175 26.1513H14.6084C14.103 26.1513 13.6929 25.7305 13.6929 25.2119V13.9394C13.6929 13.4208 14.103 13 14.6084 13H31.0888C31.5942 13 32.0043 13.4208 32.0043 13.9394V18.6363H30.1732V14.8788H15.524V24.2726H21.0175V26.1513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2576 28.0301C26.5558 28.0301 24.3108 27.4298 22.8486 26.4218C22.8486 27.1226 22.8486 27.5848 22.8486 28.0301C22.8486 29.5866 25.718 30.8482 29.2576 30.8482C32.7972 30.8482 35.6667 29.5866 35.6667 28.0301C35.6667 27.5848 35.6667 27.1226 35.6667 26.4218C34.2045 27.4298 31.9595 28.0301 29.2576 28.0301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2576 32.727C26.5558 32.727 24.3108 32.1267 22.8486 31.1187C22.8486 31.8195 22.8486 32.2817 22.8486 32.727C22.8486 34.2835 25.718 35.5451 29.2576 35.5451C32.7972 35.5451 35.6667 34.2835 35.6667 32.727C35.6667 32.2817 35.6667 31.8195 35.6667 31.1187C34.2045 32.1267 31.9595 32.727 29.2576 32.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8497 21.1463C22.4778 20.3939 23.4373 19.7795 24.6569 19.3464C24.5461 18.4202 23.7825 17.6969 22.8486 17.6969C21.8387 17.6969 21.0175 18.5395 21.0175 19.5757C21.0175 20.2332 21.3498 20.8109 21.8497 21.1463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2576 26.1513C32.7972 26.1513 35.6667 24.8896 35.6667 23.3332C35.6667 21.7768 32.7972 20.515 29.2576 20.515C25.718 20.515 22.8486 21.7768 22.8486 23.3332C22.8486 24.8896 25.718 26.1513 29.2576 26.1513Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3813_1167",
    x1: 8.19287,
    y1: 7,
    x2: 37.6929,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E72E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825EE4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3813_1167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9737,
    height: 22.5451,
    fill: "white",
    transform: "translate(13.6929 13)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStatisticsCardIconRoound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/StatisticsCardIconRoound.c29037a5f09a728d192c6c6f4fcac811.svg";